<script lang="ts" module>
  export interface BreadcrumbItem {
    name: string;
    item: string;
  }
</script>

<script lang="ts">
  import { page } from '$app/state';
  import { JsonLd } from '@agapi/ui/json-ld';

  export let items: BreadcrumbItem[];

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.item
    }))
  };
</script>

<JsonLd data={schemaData} />
